module.exports = __webpack_public_path__ + "img/game.debf3e8.png";